import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ScContentTemplate, ScStep, ScStepConfig } from '../../models';
import { ScStepService } from './sc-step.service';
import { ScTemplateService } from './sc-template.service';

@Component({
  selector: 'sc-vertical-stepper',
  templateUrl: './sc-vertical-stepper.component.html',
  styleUrls: ['./sc-vertical-stepper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScVerticalStepperComponent implements OnInit, OnChanges, AfterViewChecked {
  @Input() public form: FormGroup;
  @Input() public preventPrevious: boolean;
  @Input() public steps: ScStepConfig[];

  public steps$: Observable<ScStep[]>;
  public footerContentTemplate$: Observable<ScContentTemplate>;
  public headerContentTemplate$: Observable<ScContentTemplate>;

  constructor(
    private _stepService: ScStepService,
    private _templateService: ScTemplateService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _cd: ChangeDetectorRef
  ) {}

  get canGoNext() {
    return this.currentStep && this.currentStep.form ? this.currentStep.form.valid : true;
  }

  get currentStepIndex() {
    return this._stepService.getStepIndex();
  }

  get currentStep() {
    return this._stepService.getStep();
  }

  get isLastStep() {
    return this._stepService.isLastStepIndex();
  }

  get previousStep() {
    return this._stepService.getPreviousStep();
  }

  get nextStep() {
    return this._stepService.getNextStep();
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.form && changes.form.currentValue) {
      this._stepService.init(this._router, this._route, this.form);
    }
  }

  public ngOnInit() {
    this.steps$ = this._stepService.getSteps();
    this.footerContentTemplate$ = this._templateService.getFooter();
    this.headerContentTemplate$ = this._templateService.getHeader();
  }

  public isStepValid(goupName: string) {
    return (
      this.form &&
      this.form.get(goupName) &&
      (this.form.get(goupName) as FormGroup).controls &&
      Object.keys((this.form.get(goupName) as FormGroup).controls).length > 0 &&
      this.form.get(goupName).valid
    );
  }

  public goNextStep() {
    this._stepService.goNextStep();
  }

  public goPreviousStep() {
    this._stepService.goPreviousStep();
  }

  public ngAfterViewChecked(): void {
    this._cd.detectChanges(); // to prevent expression after view checked
  }

  public trackByIndex = (index: number): number => index;
}
